import * as pPay from "./p-pay";
import * as tPay from "./t-pay";

export const danal = {
    ...pPay,
    ...tPay,
}
